import Vue from 'vue'
import VueRouter from 'vue-router'
import Video from '../views/Video.vue'
import Introduction from '../views/Introduction.vue'
import Comment from '../views/Comment.vue'
import Activity from '../views/Activity.vue'
import ActivityResult from '../views/ActivityResult.vue' 
import ActivityShare from '../views/ActivityShare.vue'
import Channel from '../views/Channel.vue'
import Audio from '../views/Audio.vue'
import IOSCardHome from "../views/card/ios/cardHome.vue"
Vue.use(VueRouter)

  const routes = [
    {
      path: '/card/ios/cardHome',
      name: 'IOSCardHome',
      component: IOSCardHome,
      meta: {
        title: '人物关系图'
      }
    },
  {
   
    path: '/video/play',
    name: 'Video',


    component: Video,
    children: [{
      path: '',
      name: 'Introduction',
      component: Introduction
    },{
      path:'comment',
      name: 'Comment',
      component: Comment
    }]
  // },
  // {
  //   path: '/audio/:courseId',
  //   name: 'Audio',
  //   props: true,
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Audio.vue')
  },{
    path: '/cms/Activity',
    name: 'Activity',
    component: Activity,
    meta: {
      title: '昆虫博物馆大调查！'
    }
  },
  {
    path: '/cms/Audio',
    name: 'Audio',
    component: Audio,
    meta: {
      title: '任务关系'
    }
  },{
    path: '/cms/ActivityResult',
    name: 'ActivityResult',
    component: ActivityResult,
    meta: {
      title: '昆虫博物馆大调查！'
    }
  },{
    path: '/cms/ActivityShare',
    name: 'ActivityShare',
    component: ActivityShare,
    meta: {
      title: '昆虫博物馆大调查！'
    }
  },
  
  {
    path: '/cms/Channel',
    name: 'Channel',
    component: Channel,
  }
  
]


const router = new VueRouter({
  mode: 'history',
  routes
})

//主要代码
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})
export default router
